import React                      from 'react'

import { alphabetically_asc }     from '../01_core'


// stupid eslint rule, function has to be in CamelCase
export function TableState ( )
{
  const [ sorted_info, set_sorted_info ] = React.useState<any>( {} )

  return { on_table_change: (pagination:any, filters:any, sorter:any) => 
           {
             set_sorted_info( sorter ) ;
           }
         , sort_col: ( col_name: string
                     , extract: ( a: any ) => any
                     , sorter: ((a:any, b:any ) => number) =  alphabetically_asc ) =>
           ({ sorter: (a:any,b:any) => sorter( extract( a ), extract( b ) )
            , key: col_name
            , sortOrder: sorted_info.columnKey === col_name? sorted_info.order : false
            })
         }
}